import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["realtor", "content", "wide", "align", "fullHeight", "contentProps", "titlePosition", "nameProps", "jobTitleProps", "quotes", "readMore", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import classNames from 'classnames';
import { DixuRow, DixuCol } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuText from "../DixuText/DixuText";
import DixuButton from "../DixuButton/DixuButton";
const DixuRealtorExperienceCard = _ref => {
  let {
      realtor,
      content,
      wide,
      align,
      fullHeight,
      contentProps,
      titlePosition,
      nameProps,
      jobTitleProps,
      quotes,
      readMore,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-realtor-experience-card', 'bg-2-1', 'box-shadow-3', {
    'dixu-realtor-experience-card--full-height': fullHeight,
    'dixu-realtor-experience-card--wide': wide
  }, className);
  const {
    0: expanded,
    1: setExpanded
  } = useState(false);
  const {
    name,
    avatar,
    jobTitle
  } = realtor || {};
  const adjustedContent = (() => {
    let newContent = content;
    if (quotes) {
      newContent = `“${content}”`;
    }
    if (readMore && typeof newContent === 'string') {
      const {
        snippet,
        remainder
      } = (() => {
        const cutIndex = newContent.indexOf('.', newContent.indexOf('.') + 1) + 1;
        return {
          snippet: newContent.slice(0, cutIndex).trim(),
          remainder: newContent.slice(cutIndex)
        };
      })();
      return /*#__PURE__*/React.createElement(DixuRow, {
        gutter: [0, 32]
      }, /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, snippet, expanded && /*#__PURE__*/React.createElement("span", null, remainder)), /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuRow, {
        justify: "center"
      }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuButton, {
        type: "outline",
        size: "lg",
        onClick: () => setExpanded(!expanded)
      }, expanded ? 'Piilota' : 'Lue lisää')))));
    }
    return newContent;
  })();
  const title = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuText, _objectSpread({
    font: '4',
    color: '2-8',
    weight: 'bold',
    align: 'center',
    block: true,
    className: 'm-b-4'
  }, nameProps), name), /*#__PURE__*/React.createElement(DixuText, _objectSpread({
    font: '3',
    color: '2-8',
    weight: 'bold',
    align: 'center',
    block: true
  }, jobTitleProps), jobTitle));
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 25]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement("div", {
    className: "dixu-realtor-experience-card__avatar-wrapper"
  }, /*#__PURE__*/React.createElement(DixuImage, {
    src: avatar,
    width: "149",
    type: "circle"
  }))))), titlePosition === 'top' && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, title), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, _objectSpread({
    align,
    font: '3',
    color: '2-8',
    weight: 'medium',
    block: true,
    whiteSpace: 'pre-line'
  }, contentProps), adjustedContent)), titlePosition === 'bottom' && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, title)));
};
DixuRealtorExperienceCard.defaultProps = {
  content: undefined,
  align: 'center',
  fullHeight: true,
  contentProps: undefined,
  titlePosition: 'top',
  nameProps: undefined,
  jobTitleProps: undefined,
  wide: false,
  quotes: false,
  readMore: false
};
export default DixuRealtorExperienceCard;